<template>
  <div>
    <navbar></navbar>
    <gd-aside></gd-aside>
    <gd-modal
      :class="{ 'open-modal' : openModal }"
      :title="currentLog.title"
      v-if="currentLog"
      @closeModal="closeModal">
      <slot>
        <div class="gd-layout-pre">
{{ currentLog.content }}
        </div>
      </slot>
    </gd-modal>
    <main class="gd-main gd-bckg-very-light-grey">
      <div class="main-layout" v-if="currentDriver">
        <h1>{{ currentDriver.name }}</h1>
        <div class="gd-small-padding-layout">
          <p class="gd-bold" v-if="currentDriver.inErrorState">
            Driver en état d'<span class="gd-tag gd-tag--red">Erreur</span> :
            <button class="gd-default-btn" @click="clickDriverNotInError()">
              Retirer l'état d'erreur
            </button>
          </p>
          <div class="gd-split-content-layout__container">
            <div class="gd-split-content-layout">
              <div class="gd-label underlined">Nom :</div>
              <div class="">{{ currentDriver.name }}</div>
              <div class="gd-label underlined">Version :</div>
              <div class="">{{ currentDriver.version }}</div>
              <div class="gd-label underlined">Nom du client :</div>
              <div class="">{{ currentDriver.clientName }}</div>
              <div class="gd-label underlined">Erreurs d'impressions :</div>
              <div class="">{{ printFailedNumber }}</div>
            </div>
            <div class="gd-split-content-layout">
              <div class="gd-label underlined">Id driver :</div>
              <div class="">{{ currentDriver.id }}</div>
              <div class="gd-label underlined">Adresse MAC :</div>
              <div class="">{{ currentDriver.macAddress }}</div>
              <div class="gd-label underlined">Nombre d'impressions :</div>
              <div class="">{{ printNumber }}</div>
            </div>
          </div>
        </div>
        <div class="gd-small-padding-layout">
          <h2>Evénements :</h2>
          <div v-if="logs.length">
            <div>
              <ul class="gd-log-list">
                <li
                  v-for="log in logs"
                  :key="log.id"
                  :id="log.id"
                  class="gd-log-list__item"
                  :class="{ 'error-log': log.isErrorLog }">
                  <div class="gd-split-table-layout">
                    <div class="gd-split-table-layout__part">
                      <div class="gd-log-list__info">
                        <span class="gd-log-list__label">Etat :</span>
                        <span v-if="log.isErrorLog" class="gd-log-list__error">Erreur</span>
                        <span v-else class="gd-log-list__success">Succès</span>
                      </div>
                      <div class="gd-log-list__info">
                        <span class="gd-log-list__label">Id du log :</span>
                        {{ log.id }}
                      </div>
                      <div class="gd-log-list__info">
                        <span class="gd-log-list__label">Date :</span>
                        {{ formatDate(log.date) }}
                      </div>
                      <div class="gd-log-list__info" v-if="log.pdfFileName">
                        <span class="gd-log-list__label">Fichier :</span>
                        {{ log.pdfFileName }}
                      </div>
                    </div>
                    <div class="gd-split-table-layout__part">
                      <span class="gd-log-list__label">Télécharger : </span>
                      <button
                        class="gd-default-btn gd-default-btn--small gd-align-middle"
                        @click="downloadLog({ driverId: $route.params.id,
                          logId: log.id,
                          logTimeStamp: formatDate(log.date) })">
                        <IconDownload class="gd-default-btn__icon"></IconDownload>
                      </button>
                      <br>
                      <span class="gd-log-list__label">Visualiser : </span>
                      <button
                        class="gd-default-btn gd-default-btn--small gd-align-middle"
                        @click="openModalFunction(log.id)">
                        <IconVisualisation class="gd-default-btn__icon"></IconVisualisation>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="gd-table__footer-cell gd-small-padding-layout">
                <pagination
                  :current="(paginationParams.from / paginationParams.count) + 1"
                  :total="paginationParams.total"
                  :limit="paginationParams.count"
                  @pageChange=pageChange></pagination>
              </div>
            </div>
          </div>
          <div v-else>
            Pas d'événement enregistré
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Aside from '@/components/Aside';
import IconDownload from '@/assets/svg/icon-download.svg';
import IconUpdate from '@/assets/svg/icon-update.svg';
import IconVisualisation from '@/assets/svg/icon-visualisation.svg';
import GdModal from '@/components/Modal';
import Navbar from '@/components/Navbar';
import Pagination from '@/components/Pagination';
import { mapActions } from 'vuex';

export default {
  name: 'driver',

  components: {
    'gd-aside': Aside,
    'gd-modal': GdModal,
    IconDownload,
    IconUpdate,
    IconVisualisation,
    Navbar,
    Pagination,
  },

  data() {
    return {
      currentDriver: undefined,
      logs: [],
      printNumber: undefined,
      printFailedNumber: undefined,
      paginationParams: {
        from: 0,
        count: 5,
        total: undefined,
      },
      openModal: false,
      currentLog: undefined,
      resultApi: '',
    };
  },

  methods: {
    ...mapActions({
      getDriver: 'drivers/getDriver',
      getLogs: 'drivers/getLogs',
      downloadLog: 'drivers/downloadLog',
      viewLog: 'drivers/viewLog',
      driverNotInError: 'drivers/driverNotInError',
    }),

    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      let month = newDate.getMonth() + 1;
      let dt = newDate.getDate();
      let hours = newDate.getHours();
      let minutes = newDate.getMinutes();
      let secondes = newDate.getSeconds();

      if (dt < 10) {
        dt = `0${dt}`;
      }
      if (month < 10) {
        month = `0${month}`;
      }
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      if (secondes < 10) {
        secondes = `0${secondes}`;
      }
      return `${dt}-${month}-${year} ${hours}:${minutes}:${secondes}`;
    },

    pageChange(from) {
      console.log(from);
      this.paginationParams.from = from;
      this.getLogs({
        id: this.$route.params.id,
        from: this.paginationParams.from,
        count: this.paginationParams.count,
      })
        .then((data) => {
          this.logs = data.logs;
        });
    },

    openModalFunction(logId) {
      this.openModal = true;
      this.viewLog({ driverId: this.$route.params.id, logId })
        .then((data) => {
          this.currentLog = { title: `Log id n°${logId}` };
          this.currentLog.content = `${data.data}`;
        });
    },

    closeModal() {
      this.openModal = false;
    },

    clickDriverNotInError() {
      this.driverNotInError(this.$route.params.id)
        .then(() => {
          this.getDriver(this.$route.params.id)
            .then((data) => {
              this.currentDriver = data.driver;
            });
        });
    },
  },

  mounted() {
    this.getDriver(this.$route.params.id)
      .then((data) => {
        this.currentDriver = data.driver;
        this.printNumber = data.totalPrinting;
        this.printFailedNumber = data.printingErrors;
      });
    this.getLogs({
      id: this.$route.params.id,
      from: this.paginationParams.from,
      count: this.paginationParams.count,
    })
      .then((data) => {
        this.logs = data.logs;
        this.paginationParams.total = data.total;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/DriverView.vue